import React, { useState, useEffect } from "react";
import Main from "../../components/Main";
import TabelaDinamica from "../../components/TabelaDinamica";
import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";
import styles from "./styles.module.css";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Paper,
  DialogContentText,
} from "@mui/material";

import Draggable from "react-draggable";
import CRUDPageHeader from "../../components/CRUDPageHeader";
import {
  atualizarContaDominio,
  buscarContasDominio,
  buscarContasDominioPorTexto,
  cadastrarContaDominio,
  deletarContaDominio,
} from "../../services/api-conciliacao.service";
import ContaDominioForm from "src/forms/ContaDominioForm";
import { NomeCompleto } from "../../utils/localStorage.util";

// Teste pontual: cadastro/exclusão via tela liberado só para esses usuários
// (nome completo, mesmo valor salvo no login) enquanto o processo continua
// sendo carga em massa para o restante. Ver commit e5ff5c5 (21/08/2026) para
// o motivo original de ter sido ocultado.
const USUARIOS_COM_GESTAO_CONTA_DOMINIO = [
  "SERGIO MAGNI",
  "CAETANO PENNAFIEL",
  "KELLY BENITES",
];

function normalizarNome(nome) {
  // Remove marcas diacríticas (acentos) após normalizar para forma decomposta,
  // comparando pelo código do caractere em vez de um literal Unicode no
  // regex, pra não depender do arquivo-fonte preservar bytes fora do ASCII.
  return Array.from((nome || "").normalize("NFD"))
    .filter((ch) => {
      const codigo = ch.codePointAt(0);
      return codigo < 0x0300 || codigo > 0x036f;
    })
    .join("")
    .trim()
    .replace(/\s+/g, " ")
    .toUpperCase();
}

function usuarioPodeGerenciarContaDominio() {
  const nomeAtual = normalizarNome(NomeCompleto.getNomeCompleto());
  return USUARIOS_COM_GESTAO_CONTA_DOMINIO.some(
    (nome) => normalizarNome(nome) === nomeAtual
  );
}

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const ContaDominio = () => {
  const [data, setData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [editRowData, setEditRowData] = useState({});
  const [openSnackbarSucesso, setOpenSnackbarSucesso] = useState(false);
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const [msg, setMsg] = useState("");
  const [openDialogExclusao, setOpenDialogExclusao] = useState(false);
  const [loading, setLoading] = useState(false);
  const podeGerenciar = usuarioPodeGerenciarContaDominio();

  const columns = [
    {
      id: "id_conciliacao_conta_contabil",
      label: "ID",
      field: "id_conciliacao_conta_contabil",
    },
    { id: "conta_contabil", label: "Conta Contábil", field: "conta_contabil" },
    { id: "classificacao", label: "Classificação", field: "classificacao" },
    { id: "Descrição", label: "Descrição", field: "descricao" },
  ];

  useEffect(() => {
    handleAtualizar();
  }, []);

  const handleOpenModal = (rowData) => {
    const isLinha =
      rowData &&
      typeof rowData === "object" &&
      rowData.id_conciliacao_conta_contabil != null;
    setEditRowData(isLinha ? rowData : {});
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleAtualizar = async () => {
    setLoading(true);
    try {
      const response = await buscarContasDominio();
      setData(response.contasContabil);
      setLoading(false);
    } catch (err) {
      if (err.response) {
        setMsg(err.response.data.mensagem);
        handleOpenSnackbarErro();
      } else {
        setMsg("Erro: Tente novamente!");
        handleOpenSnackbarErro();
      }
      setLoading(false);
    }
  };

  const extrairMensagemErro = (err) =>
    err.response?.data?.mensagem ??
    err.response?.data?.message ??
    "Erro: Tente novamente!";

  const handleSaveChanges = async (data) => {
    if (!editRowData.id_conciliacao_conta_contabil) {
      // Cadastra
      await cadastrarContaDominio(data)
        .then(async (response) => {
          setMsg(response.data?.mensagem ?? response.mensagem);
          handleOpenSnackbarSucesso();
          handleAtualizar();
          handleCloseModal();
        })
        .catch((err) => {
          if (err.response) {
            setMsg(extrairMensagemErro(err));
            handleOpenSnackbarErro();
          } else {
            setMsg("Erro: Tente novamente!");
            handleOpenSnackbarErro();
          }
        });
    } else {
      //Atualiza
      await atualizarContaDominio(
        editRowData.id_conciliacao_conta_contabil,
        data
      )
        .then(async (response) => {
          setMsg(response.data?.mensagem ?? response.mensagem);
          handleOpenSnackbarSucesso();
          handleAtualizar();
          handleCloseModal();
        })
        .catch((err) => {
          if (err.response) {
            setMsg(extrairMensagemErro(err));
            handleOpenSnackbarErro();
          } else {
            setMsg("Erro: Tente novamente!");
            handleOpenSnackbarErro();
          }
        });
    }
  };

  const handleDelete = async () => {
    await deletarContaDominio(editRowData.id_conciliacao_conta_contabil)
      .then(async (response) => {
        setMsg(response.data?.mensagem ?? response.mensagem);
        // Buscar dados novamente para renderizar
        handleOpenSnackbarSucesso();
        handleAtualizar();
        handleCloseDialogExclusao();
      })
      .catch((err) => {
        if (err.response) {
          setMsg(err.response.data.mensagem);
          handleOpenSnackbarErro();
        } else {
          setMsg("Erro: Tente novamente!");
          handleOpenSnackbarErro();
        }
      });
  };

  const handleDebounceChange = async (event) => {
    try {
      const response = await buscarContasDominioPorTexto(
        event.target.value.toUpperCase()
      );
      setData(response.contasContabil);
    } catch (err) {
      console.log(err);
      if (err.response) {
        if (err.response.status === 404) {
          setData([]);
        } else {
          setMsg(err.response.data.mensagem);
          handleOpenSnackbarErro();
        }
      } else {
        setMsg("Erro: Tente novamente!");
        handleOpenSnackbarErro();
      }
    }
  };

  const handleOpenSnackbarSucesso = () => {
    setOpenSnackbarSucesso(true);
  };

  const handleCloseSnackbarSucesso = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarSucesso(false);
  };

  const handleOpenSnackbarErro = () => {
    setOpenSnackbarErro(true);
  };

  const handleCloseSnackbarErro = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };

  const handleClickOpenDialogExclusao = (rowData) => {
    setEditRowData(rowData);
    setOpenDialogExclusao(true);
  };

  const handleCloseDialogExclusao = () => {
    setOpenDialogExclusao(false);
  };

  return (
    <div>
      <Main />

      <CRUDPageHeader
        headerIcon={
          <>
            <AccountBalanceWalletIcon />
          </>
        }
        headerTitle="Contas Domínio"
        modalButtonLabel={"Adicionar"}
        handleOpenModal={handleOpenModal}
        handleDebounceChange={handleDebounceChange}
        disableModalButton={!podeGerenciar}
      />

      <TabelaDinamica
        data={data}
        columns={columns}
        loading={loading}
        disableEdit
        disableDelete={!podeGerenciar}
        onDeleteButtonClick={handleClickOpenDialogExclusao}
      />
      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: { maxWidth: 480 },
        }}
      >
        <DialogTitle sx={{pb:0}}>
          <div className={styles.tituloPopupContainer}>
            <AccountBalanceWalletIcon sx={{fontSize: '30px'}} />
            <h1 className={styles.tituloPopup}>Conta Domínio</h1>
          </div>
        </DialogTitle>
        <DialogContent sx={{m:0, p:0}}>
          <ContaDominioForm
            contaDominioValues={Object.assign({}, editRowData)}
            onSubmit={handleSaveChanges}
            onClose={handleCloseModal}
          />
        </DialogContent>
      </Dialog>

      {/* Dialog de exclusão */}
      <Dialog
        open={openDialogExclusao}
        onClose={handleCloseDialogExclusao}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle
          className={styles.tituloExclusao}
          style={{ cursor: "move" }}
          id="draggable-dialog-title"
        >
          Atenção!
        </DialogTitle>
        <DialogContent>
          <DialogContentText className={styles.textoExclusao}>
            Você realmente deseja excluir a conta contábil{" "}
            {editRowData.conta_contabil}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className={styles.botaoPopupCancelarExclusao}
            autoFocus
            onClick={handleCloseDialogExclusao}
          >
            Cancelar
          </Button>
          <Button className={styles.botaoPopupExcluir} onClick={handleDelete}>
            Sim
          </Button>
        </DialogActions>
      </Dialog>

      <MensagemSucesso
        open={openSnackbarSucesso}
        handleClose={handleCloseSnackbarSucesso}
        msg={msg}
      />

      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />
    </div>
  );
};

export default ContaDominio;
